import React from 'react';
import { array, object, number } from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { I18n } from '@fiverr-private/fiverr_context';
import { getPackageTypeById, hasRecommendedPackage, isRecommendedPackage } from '../../../utils/packagesUtils';
import TabContent from '../TabContent';
import CheckoutFormHOC from '../../shared/CheckoutFormHOC';
import { selectPackage } from '../../../actions/packages';
import { PACKAGE_POSITIONS } from '../../../types/packagePositions';
import { reportTabClickEvents } from './utils';

import './style.scss';

const TriplePackage = (
    { packageList, selectedPackageId, selectPackage },
    { biEvents }
) => {
    const onPackageChange = (id) => {
        selectPackage({ packageId: id });
        reportTabClickEvents(biEvents, id);
    };

    const className = classnames('packages-tabs', 'triple', {
        'recommended': hasRecommendedPackage(packageList)
    });
    const selectedPackage = packageList.find((packageData) => packageData.id === selectedPackageId);
    const packageClassName = classnames('content', { 'recommended': isRecommendedPackage(selectedPackage) });

    return (
        <div className={className}>
            {packageList.map(({ id }) => (
                <input key={id} id={`package-tab-${id}`} name="package-tab-group"
                    type="radio" checked={selectedPackageId === id}/>
            ))}

            <div className="nav-container">
                {packageList.map(({ id }) => (
                    <label key={id} htmlFor={`package-tab-${id}`}
                        onClick={() => onPackageChange(id)}>
                        <I18n k={getPackageTypeById(id)}/>
                    </label>
                ))}
            </div>

            <CheckoutFormHOC className={packageClassName} selectedPackageId={selectedPackage.id}
                source={PACKAGE_POSITIONS.TABS}>
                <TabContent id={selectedPackage.id}/>
            </CheckoutFormHOC>
        </div>
    );
};

TriplePackage.propTypes = {
    packageList: array,
    selectedPackageId: number
};

TriplePackage.contextTypes = {
    biEvents: object
};

const mapStateToProps = ({ packages }) => ({
    packageList: packages.packageList,
    selectedPackageId: packages.selectedPackageId
});

export { TriplePackage };
export default connect(mapStateToProps, { selectPackage })(TriplePackage);
